module.exports = __webpack_public_path__ + "img/logo5px.a48f43ca.svg";